import {
  FETCH_POSTS_REQUEST,
  FETCH_POSTS_SUCCESS,
  FETCH_POSTS_ERROR,
} from '../constants';

export default function(state = {}, action) {
  switch (action.type) {
    case FETCH_POSTS_REQUEST:
    case FETCH_POSTS_ERROR:
      return state;

    case FETCH_POSTS_SUCCESS:
      return action.payload;

    default:
      break;
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/store/reducers/fetch_posts_reducer.js